export default {
      id: "delete-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#delete",
      toString: function () {
        return this.url;
      }
    }